import Vue from 'vue';

import App from './App.vue';

import store from './store';
import vuetify from './plugins/vuetify';
import { router } from './routes';

// import VueTheMask from 'vue-the-mask'
// Vue.use(VueTheMask)

import './registerServiceWorker';

Vue.config.productionTip = false;
Vue.config.performance = process.env.NODE_ENV !== 'production';

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
